const underscoreStrip = function () {
  return function (text) {
    return text.replace(/_/g, ' ')
  }
}

export default underscoreStrip
